/* AUTO-GENERATED from Sundays_in_Bed_Klang_Valley_Cost_Model_V9_Final.xlsx (MODEL_CONFIG sheet).
   Generator: generate_boq_data_v9.py — regenerate from the workbook if the model changes,
   do not hand-edit numbers here. Supersedes the v7 workbook this file used to be generated
   from (see generate_boq_data_v7.py for that history). Tier vocabulary is unchanged from v7
   (Essential/Premium/Signature). v9 adds: a whole-home size-zone quantity engine (private
   built-ins / shared cabinetry scale modestly with built-up area, never as a final-price
   multiplier — SIZE_ZONES), a bedroom-count-aware shared-storage factor that applies only to
   household-linked shared cabinetry, not to each bedroom's own wardrobe (BEDROOM_SHARED_
   FACTORS), a genuine three-scope Low/Expected/High model instead of one scope at three
   prices (RULES.scopeClass + v9HighEligible, resolved by the engine per band — see
   sib-boq-engine.js), a Premium-tier Low-band FF&E price that blends 50% Essential + 50%
   Premium unit pricing (PROJECT_DEFAULTS.premiumLow*Share), and a Signature-tier FF&E price
   that blends the Premium rate with a separate luxury/imported reference rate at band-
   specific shares instead of using a flat Signature rate column (SIGNATURE_BRAND_MIX;
   RATES[item].signatureRate is null for every item this applies to — that is intentional,
   not missing data). Large-format loose furniture (bed, sofa, coffee/dining table, outdoor
   set — RATES[item].largeRoomScale) also gets a room-area-band size factor per tier
   (LARGE_ROOM_SCALE) — present in the workbook since at least v7/v8 but never actually
   wired up until this v9 generator; a real gap in what v7 shipped, noted for the record. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) { module.exports = factory(); }
  else { root.SIBBoqData = factory(); }
}(typeof self !== 'undefined' ? self : this, function () {
  'use strict';
  return {
  "TIER_NAMES": [
    "Essential",
    "Premium",
    "Signature"
  ],
  "RULES": [
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Existing floor hacking / removal",
      "workGroup": "Hacking",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Floor finish - dry",
      "workGroup": "Flooring / Tiling",
      "qtyMethod": "AreaWaste",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": "Dry",
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Skirting",
      "workGroup": "Flooring / Tiling",
      "qtyMethod": "Perimeter",
      "unit": "lin ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 0.9,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Paint - walls & ceiling",
      "workGroup": "Painting",
      "qtyMethod": "WallPlusCeiling",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Plaster ceiling",
      "workGroup": "Plaster ceiling",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 0.6,
      "signatureMult": 0.55,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Lighting point - ceiling",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Lux",
      "unit": "point",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 150,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Downlight / ceiling fixture",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Lux",
      "unit": "unit",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0.6,
      "premiumMult": 0.6,
      "signatureMult": 0.6,
      "targetLux": 150,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "13A socket point",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "BaseAreaDriver",
      "unit": "point",
      "baseQty": 5,
      "areaStart": 150,
      "areaStep": 250,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 10,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 3,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Feature wall finish",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "sq ft",
      "baseQty": 40,
      "areaStart": 150,
      "areaStep": 200,
      "areaInc": 20,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 120,
      "qtyFactor": 1,
      "minArea": 150,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Lighting point - accent / wall",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0,
      "premiumMult": 2,
      "signatureMult": 2,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Accent / wall light fixture",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Fixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0.0,
      "premiumMult": 1.2,
      "signatureMult": 1.2,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "Electrical Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Dedicated appliance / AC point",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Data / TV point",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "ThresholdFixed",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 250,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Ceiling fan",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Fixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0.6,
      "premiumMult": 0.6,
      "signatureMult": 0.6,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "Electrical Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Dimmer / smart control",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 3,
      "maxTierIdx": 3,
      "essentialMult": 0,
      "premiumMult": 0,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Wardrobe",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 6,
      "areaStart": 150,
      "areaStep": 150,
      "areaInc": 2,
      "driverStart": 1,
      "driverInc": 2,
      "maxQty": 20,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0.9,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "Private built-in",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Dressing / study built-in",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 3,
      "areaStart": 250,
      "areaStep": 300,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 8,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "Private built-in",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Custom headboard",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 8,
      "areaStart": 250,
      "areaStep": 250,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 14,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Bed & mattress",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Loose headboard",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 2,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Bedside table",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 2,
      "signatureMult": 2,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Accent / lounge chair",
      "workGroup": "FF&E",
      "qtyMethod": "ThresholdFixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 350,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Side table",
      "workGroup": "FF&E",
      "qtyMethod": "ThresholdFixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 500,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Curtains / blinds set",
      "workGroup": "FF&E",
      "qtyMethod": "BaseAreaDriver",
      "unit": "window set",
      "baseQty": 1,
      "areaStart": 450,
      "areaStep": 450,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 2,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Rug / decor allowance",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Aircon 1.0HP",
      "workGroup": "HVAC / Aircon",
      "qtyMethod": "ThresholdFixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 1,
      "maxArea": 180,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Aircon 1.5HP",
      "workGroup": "HVAC / Aircon",
      "qtyMethod": "ThresholdFixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 181,
      "maxArea": 320,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Aircon 2.0HP",
      "workGroup": "HVAC / Aircon",
      "qtyMethod": "ThresholdFixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 321,
      "maxArea": 500,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bedroom",
      "subtype": "*",
      "item": "Aircon 2.5HP+",
      "workGroup": "HVAC / Aircon",
      "qtyMethod": "BaseAreaDriver",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 700,
      "areaStep": 500,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 2,
      "qtyFactor": 1,
      "minArea": 501,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "Existing floor hacking / removal",
      "workGroup": "Hacking",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "Floor finish - dry",
      "workGroup": "Flooring / Tiling",
      "qtyMethod": "AreaWaste",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": "Dry",
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "Skirting",
      "workGroup": "Flooring / Tiling",
      "qtyMethod": "Perimeter",
      "unit": "lin ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 0.9,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "Paint - walls & ceiling",
      "workGroup": "Painting",
      "qtyMethod": "WallPlusCeiling",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "Plaster ceiling",
      "workGroup": "Plaster ceiling",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 0.6,
      "signatureMult": 0.65,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "Lighting point - ceiling",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Lux",
      "unit": "point",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 200,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 2,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "Downlight / ceiling fixture",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Lux",
      "unit": "unit",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0.6,
      "premiumMult": 0.6,
      "signatureMult": 0.6,
      "targetLux": 200,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "13A socket point",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "BaseAreaDriver",
      "unit": "point",
      "baseQty": 4,
      "areaStart": 180,
      "areaStep": 150,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 10,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 4,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "Feature wall finish",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "sq ft",
      "baseQty": 60,
      "areaStart": 220,
      "areaStep": 200,
      "areaInc": 25,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 160,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "Dedicated appliance / AC point",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "BaseAreaDriver",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 350,
      "areaStep": 350,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 3,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "Data / TV point",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "LED strip",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 4,
      "areaStart": 250,
      "areaStep": 250,
      "areaInc": 2,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 12,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "Ceiling fan",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "BaseAreaDriver",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 450,
      "areaStep": 450,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 2,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0.6,
      "premiumMult": 0.6,
      "signatureMult": 0.6,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "Electrical Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "Dimmer / smart control",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 2,
      "maxTierIdx": 3,
      "essentialMult": 0,
      "premiumMult": 1,
      "signatureMult": 2,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "TV / media carpentry",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 6,
      "areaStart": 180,
      "areaStep": 150,
      "areaInc": 2,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 16,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "Shared cabinetry",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "Display / storage cabinetry",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 4,
      "areaStart": 300,
      "areaStep": 250,
      "areaInc": 2,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 12,
      "qtyFactor": 1,
      "minArea": 250,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "Shared cabinetry",
      "v9BedroomLinked": true,
      "v9HighEligible": true
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "Sofa seating group",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "Accent / lounge chair",
      "workGroup": "FF&E",
      "qtyMethod": "BaseAreaDriver",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 220,
      "areaStep": 220,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 3,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "Coffee table",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "Side table",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0,
      "premiumMult": 1,
      "signatureMult": 2,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "Curtains / blinds set",
      "workGroup": "FF&E",
      "qtyMethod": "BaseAreaDriver",
      "unit": "window set",
      "baseQty": 1,
      "areaStart": 300,
      "areaStep": 300,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 3,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "Rug / decor allowance",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "Aircon 1.5HP",
      "workGroup": "HVAC / Aircon",
      "qtyMethod": "ThresholdFixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 1,
      "maxArea": 200,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "Aircon 2.0HP",
      "workGroup": "HVAC / Aircon",
      "qtyMethod": "ThresholdFixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 201,
      "maxArea": 350,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Living room",
      "subtype": "*",
      "item": "Aircon 2.5HP+",
      "workGroup": "HVAC / Aircon",
      "qtyMethod": "BaseAreaDriver",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 500,
      "areaStep": 500,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 2,
      "qtyFactor": 1,
      "minArea": 351,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Dining room",
      "subtype": "*",
      "item": "Existing floor hacking / removal",
      "workGroup": "Hacking",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Dining room",
      "subtype": "*",
      "item": "Floor finish - dry",
      "workGroup": "Flooring / Tiling",
      "qtyMethod": "AreaWaste",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": "Dry",
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Dining room",
      "subtype": "*",
      "item": "Skirting",
      "workGroup": "Flooring / Tiling",
      "qtyMethod": "Perimeter",
      "unit": "lin ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 0.9,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Dining room",
      "subtype": "*",
      "item": "Paint - walls & ceiling",
      "workGroup": "Painting",
      "qtyMethod": "WallPlusCeiling",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Dining room",
      "subtype": "*",
      "item": "Plaster ceiling",
      "workGroup": "Plaster ceiling",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 0.6,
      "signatureMult": 0.65,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Dining room",
      "subtype": "*",
      "item": "Lighting point - ceiling",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Lux",
      "unit": "point",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 200,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Dining room",
      "subtype": "*",
      "item": "Downlight / ceiling fixture",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Lux",
      "unit": "unit",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0.6,
      "premiumMult": 0.6,
      "signatureMult": 0.6,
      "targetLux": 200,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Dining room",
      "subtype": "*",
      "item": "13A socket point",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "BaseAreaDriver",
      "unit": "point",
      "baseQty": 2,
      "areaStart": 120,
      "areaStep": 120,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 6,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Dining room",
      "subtype": "*",
      "item": "Lighting point - accent / wall",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Dining room",
      "subtype": "*",
      "item": "Dimmer / smart control",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 2,
      "maxTierIdx": 3,
      "essentialMult": 0,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Dining room",
      "subtype": "*",
      "item": "Display / storage cabinetry",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 4,
      "areaStart": 130,
      "areaStep": 100,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 10,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "Shared cabinetry",
      "v9BedroomLinked": true,
      "v9HighEligible": true
    },
    {
      "roomType": "Dining room",
      "subtype": "*",
      "item": "Feature wall finish",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "sq ft",
      "baseQty": 40,
      "areaStart": 160,
      "areaStep": 120,
      "areaInc": 20,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 100,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Dining room",
      "subtype": "*",
      "item": "Dining table",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Dining room",
      "subtype": "*",
      "item": "Dining chair",
      "workGroup": "FF&E",
      "qtyMethod": "DriverOrArea",
      "unit": "unit",
      "baseQty": 4,
      "areaStart": 100,
      "areaStep": 80,
      "areaInc": 2,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 12,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Dining room",
      "subtype": "*",
      "item": "Pendant / chandelier",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Dining room",
      "subtype": "*",
      "item": "Rug / decor allowance",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Dining room",
      "subtype": "*",
      "item": "Curtains / blinds set",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "window set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Dining room",
      "subtype": "*",
      "item": "Aircon 1.0HP",
      "workGroup": "HVAC / Aircon",
      "qtyMethod": "ThresholdFixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 1,
      "maxArea": 140,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Dining room",
      "subtype": "*",
      "item": "Aircon 1.5HP",
      "workGroup": "HVAC / Aircon",
      "qtyMethod": "ThresholdFixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 141,
      "maxArea": 230,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Dining room",
      "subtype": "*",
      "item": "Aircon 2.0HP",
      "workGroup": "HVAC / Aircon",
      "qtyMethod": "ThresholdFixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 231,
      "maxArea": 350,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Dining room",
      "subtype": "*",
      "item": "Aircon 2.5HP+",
      "workGroup": "HVAC / Aircon",
      "qtyMethod": "ThresholdFixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 351,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Kitchen",
      "subtype": "*",
      "item": "Existing floor hacking / removal",
      "workGroup": "Hacking",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Kitchen",
      "subtype": "*",
      "item": "Floor tile - wet",
      "workGroup": "Wet tiling",
      "qtyMethod": "AreaWaste",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": "Wet",
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Kitchen",
      "subtype": "*",
      "item": "Paint - walls & ceiling",
      "workGroup": "Painting",
      "qtyMethod": "WallPlusCeiling",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 0.35,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Kitchen",
      "subtype": "*",
      "item": "Plaster ceiling",
      "workGroup": "Plaster ceiling",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 0.6,
      "signatureMult": 0.55,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Kitchen",
      "subtype": "*",
      "item": "Lighting point - ceiling",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Lux",
      "unit": "point",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 300,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Kitchen",
      "subtype": "*",
      "item": "Downlight / ceiling fixture",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Lux",
      "unit": "unit",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0.6,
      "premiumMult": 0.6,
      "signatureMult": 0.6,
      "targetLux": 300,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Kitchen",
      "subtype": "*",
      "item": "13A socket point",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "BaseAreaDriver",
      "unit": "point",
      "baseQty": 4,
      "areaStart": 40,
      "areaStep": 20,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 10,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 4,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Kitchen",
      "subtype": "*",
      "item": "Dedicated appliance / AC point",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "BaseAreaDriver",
      "unit": "point",
      "baseQty": 3,
      "areaStart": 50,
      "areaStep": 30,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 8,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 2,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Kitchen",
      "subtype": "*",
      "item": "LED strip",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 6,
      "areaStart": 40,
      "areaStep": 20,
      "areaInc": 2,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 18,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Kitchen",
      "subtype": "*",
      "item": "Hot/cold water point",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 2,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Plumbing Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Kitchen",
      "subtype": "*",
      "item": "Drain / waste point",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Plumbing Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Kitchen",
      "subtype": "*",
      "item": "Kitchen base cabinet",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 8,
      "areaStart": 40,
      "areaStep": 15,
      "areaInc": 2,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 24,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "Shared cabinetry",
      "v9BedroomLinked": true,
      "v9HighEligible": false
    },
    {
      "roomType": "Kitchen",
      "subtype": "*",
      "item": "Kitchen wall cabinet",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 8,
      "areaStart": 40,
      "areaStep": 15,
      "areaInc": 2,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 24,
      "qtyFactor": 0.75,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "Shared cabinetry",
      "v9BedroomLinked": true,
      "v9HighEligible": false
    },
    {
      "roomType": "Kitchen",
      "subtype": "*",
      "item": "Kitchen tall cabinet",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 2,
      "areaStart": 60,
      "areaStep": 40,
      "areaInc": 2,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 8,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0.5,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "Shared cabinetry",
      "v9BedroomLinked": true,
      "v9HighEligible": false
    },
    {
      "roomType": "Kitchen",
      "subtype": "*",
      "item": "Kitchen countertop",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "sq ft",
      "baseQty": 8,
      "areaStart": 40,
      "areaStep": 15,
      "areaInc": 2,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 24,
      "qtyFactor": 2.1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Kitchen",
      "subtype": "*",
      "item": "Kitchen backsplash",
      "workGroup": "Wet tiling",
      "qtyMethod": "BaseAreaDriver",
      "unit": "sq ft",
      "baseQty": 8,
      "areaStart": 40,
      "areaStep": 15,
      "areaInc": 2,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 24,
      "qtyFactor": 2,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Kitchen",
      "subtype": "*",
      "item": "Kitchen island",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 4,
      "areaStart": 120,
      "areaStep": 80,
      "areaInc": 2,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 8,
      "qtyFactor": 1,
      "minArea": 120,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Kitchen",
      "subtype": "*",
      "item": "Kitchen sink & tap",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "Fixed",
      "unit": "set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Sanitary Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Kitchen",
      "subtype": "*",
      "item": "Hood & hob",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Kitchen",
      "subtype": "*",
      "item": "Kitchen appliance set",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Kitchen",
      "subtype": "Wet + Dry",
      "item": "Wet/dry kitchen partition",
      "workGroup": "Carpentry",
      "qtyMethod": "Fixed",
      "unit": "set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Home office",
      "subtype": "*",
      "item": "Existing floor hacking / removal",
      "workGroup": "Hacking",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Home office",
      "subtype": "*",
      "item": "Floor finish - dry",
      "workGroup": "Flooring / Tiling",
      "qtyMethod": "AreaWaste",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": "Dry",
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Home office",
      "subtype": "*",
      "item": "Skirting",
      "workGroup": "Flooring / Tiling",
      "qtyMethod": "Perimeter",
      "unit": "lin ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 0.9,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Home office",
      "subtype": "*",
      "item": "Paint - walls & ceiling",
      "workGroup": "Painting",
      "qtyMethod": "WallPlusCeiling",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Home office",
      "subtype": "*",
      "item": "Plaster ceiling",
      "workGroup": "Plaster ceiling",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 0.6,
      "signatureMult": 0.55,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Home office",
      "subtype": "*",
      "item": "Lighting point - ceiling",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Lux",
      "unit": "point",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 400,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Home office",
      "subtype": "*",
      "item": "Downlight / ceiling fixture",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Lux",
      "unit": "unit",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0.6,
      "premiumMult": 0.6,
      "signatureMult": 0.6,
      "targetLux": 400,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Home office",
      "subtype": "*",
      "item": "13A socket point",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "BaseAreaDriver",
      "unit": "point",
      "baseQty": 4,
      "areaStart": 80,
      "areaStep": 80,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 10,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 3,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Home office",
      "subtype": "*",
      "item": "Dedicated appliance / AC point",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Home office",
      "subtype": "*",
      "item": "Data / TV point",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "DriverOrArea",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 120,
      "areaStep": 120,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 4,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Home office",
      "subtype": "*",
      "item": "Dimmer / smart control",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 3,
      "maxTierIdx": 3,
      "essentialMult": 0,
      "premiumMult": 0,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Home office",
      "subtype": "*",
      "item": "Dressing / study built-in",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 5,
      "areaStart": 100,
      "areaStep": 100,
      "areaInc": 2,
      "driverStart": 1,
      "driverInc": 3,
      "maxQty": 14,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "Private built-in",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Home office",
      "subtype": "*",
      "item": "Display / storage cabinetry",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 4,
      "areaStart": 120,
      "areaStep": 100,
      "areaInc": 2,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 12,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "Shared cabinetry",
      "v9BedroomLinked": true,
      "v9HighEligible": true
    },
    {
      "roomType": "Home office",
      "subtype": "*",
      "item": "Loose desk",
      "workGroup": "FF&E",
      "qtyMethod": "DriverOrArea",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 120,
      "areaStep": 120,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 2,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Home office",
      "subtype": "*",
      "item": "Desk chair",
      "workGroup": "FF&E",
      "qtyMethod": "DriverOrArea",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 140,
      "areaStep": 140,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 3,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Home office",
      "subtype": "*",
      "item": "Accent / lounge chair",
      "workGroup": "FF&E",
      "qtyMethod": "ThresholdFixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 180,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Home office",
      "subtype": "*",
      "item": "Curtains / blinds set",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "window set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Home office",
      "subtype": "*",
      "item": "Rug / decor allowance",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Home office",
      "subtype": "*",
      "item": "Aircon 1.0HP",
      "workGroup": "HVAC / Aircon",
      "qtyMethod": "ThresholdFixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 1,
      "maxArea": 160,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Home office",
      "subtype": "*",
      "item": "Aircon 1.5HP",
      "workGroup": "HVAC / Aircon",
      "qtyMethod": "ThresholdFixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 161,
      "maxArea": 280,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Home office",
      "subtype": "*",
      "item": "Aircon 2.0HP",
      "workGroup": "HVAC / Aircon",
      "qtyMethod": "ThresholdFixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 281,
      "maxArea": 450,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Home office",
      "subtype": "*",
      "item": "Aircon 2.5HP+",
      "workGroup": "HVAC / Aircon",
      "qtyMethod": "ThresholdFixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 451,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Balcony",
      "subtype": "*",
      "item": "Existing floor hacking / removal",
      "workGroup": "Hacking",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Balcony",
      "subtype": "*",
      "item": "Floor tile - wet",
      "workGroup": "Wet tiling",
      "qtyMethod": "AreaWaste",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": "Wet",
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Balcony",
      "subtype": "*",
      "item": "Paint - walls & ceiling",
      "workGroup": "Painting",
      "qtyMethod": "WallPlusCeiling",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 0.35,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Balcony",
      "subtype": "*",
      "item": "Waterproofing - floor",
      "workGroup": "Waterproofing",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Balcony",
      "subtype": "*",
      "item": "Lighting point - ceiling",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "BaseAreaDriver",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 60,
      "areaStep": 60,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 4,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Balcony",
      "subtype": "*",
      "item": "Downlight / ceiling fixture",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "BaseAreaDriver",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 60,
      "areaStep": 60,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 4,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0.6,
      "premiumMult": 0.6,
      "signatureMult": 0.6,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Balcony",
      "subtype": "*",
      "item": "13A socket point",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "BaseAreaDriver",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 120,
      "areaStep": 120,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 2,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Balcony",
      "subtype": "*",
      "item": "Built-in bench / storage",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 4,
      "areaStart": 120,
      "areaStep": 100,
      "areaInc": 2,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 8,
      "qtyFactor": 1,
      "minArea": 80,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "Shared cabinetry",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Balcony",
      "subtype": "*",
      "item": "Outdoor furniture set",
      "workGroup": "FF&E",
      "qtyMethod": "ThresholdFixed",
      "unit": "set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 30,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Balcony",
      "subtype": "*",
      "item": "Planter / greenery set",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Balcony",
      "subtype": "*",
      "item": "Ceiling fan",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "ThresholdFixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 150,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0.6,
      "premiumMult": 0.6,
      "signatureMult": 0.6,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "Electrical Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "Existing floor hacking / removal",
      "workGroup": "Hacking",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "Existing wall tile hacking / removal",
      "workGroup": "Hacking",
      "qtyMethod": "BathWallTile",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 0.85,
      "tiledHeight": 7.5,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "Floor tile - wet",
      "workGroup": "Wet tiling",
      "qtyMethod": "AreaWaste",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": "Wet",
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "Wall tile - wet",
      "workGroup": "Wet tiling",
      "qtyMethod": "BathWallTile",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 0.85,
      "tiledHeight": 7.5,
      "wasteClass": "Wet",
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "Paint - walls & ceiling",
      "workGroup": "Painting",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "Plaster ceiling",
      "workGroup": "Plaster ceiling",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "Waterproofing - floor",
      "workGroup": "Waterproofing",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "Waterproofing - shower walls",
      "workGroup": "Waterproofing",
      "qtyMethod": "Fixed",
      "unit": "sq ft",
      "baseQty": 50,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "Lighting point - ceiling",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Lux",
      "unit": "point",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 200,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "Downlight / ceiling fixture",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Lux",
      "unit": "unit",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0.6,
      "premiumMult": 0.6,
      "signatureMult": 0.6,
      "targetLux": 200,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "Lighting point - accent / wall",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "Accent / wall light fixture",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Fixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0.6,
      "premiumMult": 0.6,
      "signatureMult": 0.6,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "Electrical Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "13A socket point",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 2,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "Dedicated appliance / AC point",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "Hot/cold water point",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 3,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Plumbing Point",
      "newDevBaselineQty": 3,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "Drain / waste point",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 2,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Plumbing Point",
      "newDevBaselineQty": 2,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "Bathroom vanity",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 2,
      "areaStart": 35,
      "areaStep": 20,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 6,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "Private built-in",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "WC",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "Fixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Sanitary Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "Basin",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "Fixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Sanitary Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "Basin tap",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "Fixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Sanitary Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "Shower set",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "Fixed",
      "unit": "set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Sanitary Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "Shower screen",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "Fixed",
      "unit": "set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "Sanitary Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "Water heater",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "Fixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Sanitary Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "Bathroom mirror",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "Bathroom accessories",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "*",
      "item": "Bathroom exhaust fan",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Fixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0.6,
      "premiumMult": 0.6,
      "signatureMult": 0.6,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "Electrical Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "Master bathroom",
      "item": "Bathtub",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "ThresholdFixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 80,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "Sanitary Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "Powder room",
      "item": "Waterproofing - shower walls",
      "workGroup": "Waterproofing",
      "qtyMethod": "Fixed",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "Powder room",
      "item": "Dedicated appliance / AC point",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "Powder room",
      "item": "Shower set",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "Fixed",
      "unit": "set",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Sanitary Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "Powder room",
      "item": "Shower screen",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "Fixed",
      "unit": "set",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "Sanitary Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "Powder room",
      "item": "Water heater",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "Fixed",
      "unit": "unit",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Sanitary Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "Powder room",
      "item": "Hot/cold water point",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 2,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Plumbing Point",
      "newDevBaselineQty": 3,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "Powder room",
      "item": "Drain / waste point",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Plumbing Point",
      "newDevBaselineQty": 2,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "Powder room",
      "item": "Wall tile - wet",
      "workGroup": "Wet tiling",
      "qtyMethod": "BathWallTile",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0.65,
      "premiumMult": 0.85,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 0.85,
      "tiledHeight": 7.5,
      "wasteClass": "Wet",
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "Master bathroom",
      "item": "Basin",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "Fixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 2,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Sanitary Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "Master bathroom",
      "item": "Basin tap",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "Fixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 2,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Sanitary Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Bathroom",
      "subtype": "Master bathroom",
      "item": "Bathroom vanity",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 4,
      "areaStart": 60,
      "areaStep": 30,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 8,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "Private built-in",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Foyer",
      "subtype": "*",
      "item": "Existing floor hacking / removal",
      "workGroup": "Hacking",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Foyer",
      "subtype": "*",
      "item": "Floor finish - dry",
      "workGroup": "Flooring / Tiling",
      "qtyMethod": "AreaWaste",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": "Dry",
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Foyer",
      "subtype": "*",
      "item": "Skirting",
      "workGroup": "Flooring / Tiling",
      "qtyMethod": "Perimeter",
      "unit": "lin ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 0.9,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Foyer",
      "subtype": "*",
      "item": "Paint - walls & ceiling",
      "workGroup": "Painting",
      "qtyMethod": "WallPlusCeiling",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Foyer",
      "subtype": "*",
      "item": "Plaster ceiling",
      "workGroup": "Plaster ceiling",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 0.6,
      "signatureMult": 0.55,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Foyer",
      "subtype": "*",
      "item": "Lighting point - ceiling",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Lux",
      "unit": "point",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 100,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Foyer",
      "subtype": "*",
      "item": "Downlight / ceiling fixture",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Lux",
      "unit": "unit",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0.6,
      "premiumMult": 0.6,
      "signatureMult": 0.6,
      "targetLux": 100,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Foyer",
      "subtype": "*",
      "item": "13A socket point",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "BaseAreaDriver",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 100,
      "areaStep": 100,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 3,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Foyer",
      "subtype": "*",
      "item": "Shoe cabinet",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 4,
      "areaStart": 60,
      "areaStep": 60,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 8,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "Shared cabinetry",
      "v9BedroomLinked": true,
      "v9HighEligible": false
    },
    {
      "roomType": "Foyer",
      "subtype": "*",
      "item": "Built-in bench / storage",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 3,
      "areaStart": 80,
      "areaStep": 80,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 6,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "Shared cabinetry",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Foyer",
      "subtype": "*",
      "item": "Feature wall finish",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "sq ft",
      "baseQty": 30,
      "areaStart": 80,
      "areaStep": 80,
      "areaInc": 15,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 80,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Foyer",
      "subtype": "*",
      "item": "Console / mirror set",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Foyer",
      "subtype": "*",
      "item": "Pendant / chandelier",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Utility / yard",
      "subtype": "*",
      "item": "Existing floor hacking / removal",
      "workGroup": "Hacking",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Utility / yard",
      "subtype": "*",
      "item": "Floor tile - wet",
      "workGroup": "Wet tiling",
      "qtyMethod": "AreaWaste",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": "Wet",
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Utility / yard",
      "subtype": "*",
      "item": "Paint - walls & ceiling",
      "workGroup": "Painting",
      "qtyMethod": "WallPlusCeiling",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 0.5,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Utility / yard",
      "subtype": "*",
      "item": "Plaster ceiling",
      "workGroup": "Plaster ceiling",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 0.6,
      "signatureMult": 0.55,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Utility / yard",
      "subtype": "*",
      "item": "Waterproofing - floor",
      "workGroup": "Waterproofing",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Utility / yard",
      "subtype": "*",
      "item": "Lighting point - ceiling",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "BaseAreaDriver",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 80,
      "areaStep": 80,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 2,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Utility / yard",
      "subtype": "*",
      "item": "Downlight / ceiling fixture",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "BaseAreaDriver",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 80,
      "areaStep": 80,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 2,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0.6,
      "premiumMult": 0.6,
      "signatureMult": 0.6,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Utility / yard",
      "subtype": "*",
      "item": "13A socket point",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "BaseAreaDriver",
      "unit": "point",
      "baseQty": 3,
      "areaStart": 80,
      "areaStep": 80,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 6,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 2,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Utility / yard",
      "subtype": "*",
      "item": "Dedicated appliance / AC point",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 2,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 2,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Utility / yard",
      "subtype": "*",
      "item": "Hot/cold water point",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Plumbing Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Utility / yard",
      "subtype": "*",
      "item": "Drain / waste point",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Plumbing Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Utility / yard",
      "subtype": "*",
      "item": "Laundry / utility cabinetry",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 3,
      "areaStart": 60,
      "areaStep": 50,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 8,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0.75,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "Shared cabinetry",
      "v9BedroomLinked": true,
      "v9HighEligible": false
    },
    {
      "roomType": "Utility / yard",
      "subtype": "*",
      "item": "Utility sink & tap",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "ThresholdFixed",
      "unit": "set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 60,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "Sanitary Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Utility / yard",
      "subtype": "*",
      "item": "Laundry drying rack",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Utility / yard",
      "subtype": "*",
      "item": "Washer / dryer set",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "Existing floor hacking / removal",
      "workGroup": "Hacking",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "Floor finish - dry",
      "workGroup": "Flooring / Tiling",
      "qtyMethod": "AreaWaste",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": "Dry",
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "Skirting",
      "workGroup": "Flooring / Tiling",
      "qtyMethod": "Perimeter",
      "unit": "lin ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 0.9,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "Paint - walls & ceiling",
      "workGroup": "Painting",
      "qtyMethod": "WallPlusCeiling",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "Plaster ceiling",
      "workGroup": "Plaster ceiling",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 0.6,
      "signatureMult": 0.65,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "Lighting point - ceiling",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Lux",
      "unit": "point",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 220,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 3,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "Downlight / ceiling fixture",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Lux",
      "unit": "unit",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0.6,
      "premiumMult": 0.6,
      "signatureMult": 0.6,
      "targetLux": 220,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "13A socket point",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "BaseAreaDriver",
      "unit": "point",
      "baseQty": 8,
      "areaStart": 350,
      "areaStep": 180,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 16,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 8,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "Feature wall finish",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "sq ft",
      "baseQty": 80,
      "areaStart": 400,
      "areaStep": 250,
      "areaInc": 30,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 220,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "Dedicated appliance / AC point",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "BaseAreaDriver",
      "unit": "point",
      "baseQty": 2,
      "areaStart": 600,
      "areaStep": 500,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 4,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 3,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "Data / TV point",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "LED strip",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 6,
      "areaStart": 400,
      "areaStep": 300,
      "areaInc": 2,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 16,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "Dimmer / smart control",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 2,
      "maxTierIdx": 3,
      "essentialMult": 0,
      "premiumMult": 1,
      "signatureMult": 3,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "TV / media carpentry",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 8,
      "areaStart": 400,
      "areaStep": 250,
      "areaInc": 2,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 18,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "Shared cabinetry",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "Display / storage cabinetry",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 4,
      "areaStart": 450,
      "areaStep": 300,
      "areaInc": 2,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 14,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "Shared cabinetry",
      "v9BedroomLinked": true,
      "v9HighEligible": true
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "Sofa seating group",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "Accent / lounge chair",
      "workGroup": "FF&E",
      "qtyMethod": "BaseAreaDriver",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 400,
      "areaStep": 250,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 3,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "Coffee table",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "Side table",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0,
      "premiumMult": 1,
      "signatureMult": 2,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "Dining table",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "Dining chair",
      "workGroup": "FF&E",
      "qtyMethod": "DriverOrArea",
      "unit": "unit",
      "baseQty": 6,
      "areaStart": 500,
      "areaStep": 200,
      "areaInc": 2,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 12,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "Pendant / chandelier",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "Curtains / blinds set",
      "workGroup": "FF&E",
      "qtyMethod": "BaseAreaDriver",
      "unit": "window set",
      "baseQty": 2,
      "areaStart": 600,
      "areaStep": 350,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 4,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "Rug / decor allowance",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": true
    },
    {
      "roomType": "Open-plan",
      "subtype": "*",
      "item": "Aircon 2.5HP+",
      "workGroup": "HVAC / Aircon",
      "qtyMethod": "BaseAreaDriver",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 500,
      "areaStep": 500,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 3,
      "qtyFactor": 1,
      "minArea": 300,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "Living + Dining + Kitchen",
      "item": "Kitchen base cabinet",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 10,
      "areaStart": 450,
      "areaStep": 100,
      "areaInc": 2,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 22,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "Shared cabinetry",
      "v9BedroomLinked": true,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "Living + Dining + Kitchen",
      "item": "Kitchen wall cabinet",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 10,
      "areaStart": 450,
      "areaStep": 100,
      "areaInc": 2,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 22,
      "qtyFactor": 0.75,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "Shared cabinetry",
      "v9BedroomLinked": true,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "Living + Dining + Kitchen",
      "item": "Kitchen tall cabinet",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 2,
      "areaStart": 500,
      "areaStep": 150,
      "areaInc": 2,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 8,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "Shared cabinetry",
      "v9BedroomLinked": true,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "Living + Dining + Kitchen",
      "item": "Kitchen countertop",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "sq ft",
      "baseQty": 10,
      "areaStart": 450,
      "areaStep": 100,
      "areaInc": 2,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 22,
      "qtyFactor": 2.1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "Living + Dining + Kitchen",
      "item": "Kitchen backsplash",
      "workGroup": "Wet tiling",
      "qtyMethod": "BaseAreaDriver",
      "unit": "sq ft",
      "baseQty": 10,
      "areaStart": 450,
      "areaStep": 100,
      "areaInc": 2,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 22,
      "qtyFactor": 2,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "Living + Dining + Kitchen",
      "item": "Kitchen island",
      "workGroup": "Carpentry",
      "qtyMethod": "BaseAreaDriver",
      "unit": "lin ft",
      "baseQty": 4,
      "areaStart": 550,
      "areaStep": 250,
      "areaInc": 2,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 8,
      "qtyFactor": 1,
      "minArea": 500,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Optional",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "Living + Dining + Kitchen",
      "item": "Hot/cold water point",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 2,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Plumbing Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "Living + Dining + Kitchen",
      "item": "Drain / waste point",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Plumbing Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "Living + Dining + Kitchen",
      "item": "Kitchen sink & tap",
      "workGroup": "Plumbing / Sanitary",
      "qtyMethod": "Fixed",
      "unit": "set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Sanitary Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "Living + Dining + Kitchen",
      "item": "Hood & hob",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Open-plan",
      "subtype": "Living + Dining + Kitchen",
      "item": "Kitchen appliance set",
      "workGroup": "FF&E",
      "qtyMethod": "Fixed",
      "unit": "set",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Typical",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Other space",
      "subtype": "*",
      "item": "Existing floor hacking / removal",
      "workGroup": "Hacking",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Other space",
      "subtype": "*",
      "item": "Floor finish - dry",
      "workGroup": "Flooring / Tiling",
      "qtyMethod": "AreaWaste",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": "Dry",
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Other space",
      "subtype": "*",
      "item": "Skirting",
      "workGroup": "Flooring / Tiling",
      "qtyMethod": "Perimeter",
      "unit": "lin ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 0.9,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Other space",
      "subtype": "*",
      "item": "Paint - walls & ceiling",
      "workGroup": "Painting",
      "qtyMethod": "WallPlusCeiling",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Other space",
      "subtype": "*",
      "item": "Plaster ceiling",
      "workGroup": "Plaster ceiling",
      "qtyMethod": "Area",
      "unit": "sq ft",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 0.6,
      "signatureMult": 0.55,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Other space",
      "subtype": "*",
      "item": "Lighting point - ceiling",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Lux",
      "unit": "point",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 150,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Other space",
      "subtype": "*",
      "item": "Downlight / ceiling fixture",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Lux",
      "unit": "unit",
      "baseQty": 0,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 0.6,
      "premiumMult": 0.6,
      "signatureMult": 0.6,
      "targetLux": 150,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Fixture",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Other space",
      "subtype": "*",
      "item": "13A socket point",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "BaseAreaDriver",
      "unit": "point",
      "baseQty": 3,
      "areaStart": 150,
      "areaStep": 150,
      "areaInc": 1,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 8,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 2,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Other space",
      "subtype": "*",
      "item": "Dedicated appliance / AC point",
      "workGroup": "Electrical / Lighting",
      "qtyMethod": "Fixed",
      "unit": "point",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 0,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "Electrical Point",
      "newDevBaselineQty": 1,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Other space",
      "subtype": "*",
      "item": "Aircon 1.0HP",
      "workGroup": "HVAC / Aircon",
      "qtyMethod": "ThresholdFixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 1,
      "maxArea": 160,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Other space",
      "subtype": "*",
      "item": "Aircon 1.5HP",
      "workGroup": "HVAC / Aircon",
      "qtyMethod": "ThresholdFixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 161,
      "maxArea": 280,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Other space",
      "subtype": "*",
      "item": "Aircon 2.0HP",
      "workGroup": "HVAC / Aircon",
      "qtyMethod": "ThresholdFixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 281,
      "maxArea": 450,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    },
    {
      "roomType": "Other space",
      "subtype": "*",
      "item": "Aircon 2.5HP+",
      "workGroup": "HVAC / Aircon",
      "qtyMethod": "ThresholdFixed",
      "unit": "unit",
      "baseQty": 1,
      "areaStart": 0,
      "areaStep": 1,
      "areaInc": 0,
      "driverStart": 0,
      "driverInc": 0,
      "maxQty": 999,
      "qtyFactor": 1,
      "minArea": 451,
      "maxArea": 99999,
      "minTierIdx": 1,
      "maxTierIdx": 3,
      "essentialMult": 1,
      "premiumMult": 1,
      "signatureMult": 1,
      "targetLux": 0,
      "coverage": 1,
      "tiledHeight": 0,
      "wasteClass": null,
      "scopeClass": "Core",
      "existingServiceClass": "None",
      "newDevBaselineQty": 0,
      "v9ZoneClass": "None",
      "v9BedroomLinked": false,
      "v9HighEligible": false
    }
  ],
  "RATES": {
    "Existing floor hacking / removal": {
      "trade": "Demolition",
      "workGroup": "Hacking",
      "unit": "sq ft",
      "essentialRate": 4,
      "premiumRate": 4,
      "signatureRate": 4,
      "ageSensitive": true,
      "layoutSensitive": false,
      "rentalClass": "Hacking / site prep",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Existing wall tile hacking / removal": {
      "trade": "Demolition",
      "workGroup": "Hacking",
      "unit": "sq ft",
      "essentialRate": 6,
      "premiumRate": 6,
      "signatureRate": 6,
      "ageSensitive": true,
      "layoutSensitive": false,
      "rentalClass": "Hacking / site prep",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Floor finish - dry": {
      "trade": "Flooring/Tiling",
      "workGroup": "Flooring / Tiling",
      "unit": "sq ft",
      "essentialRate": 8,
      "premiumRate": 14,
      "signatureRate": 25,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Durable flooring / tiles",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Floor tile - wet": {
      "trade": "Flooring/Tiling",
      "workGroup": "Wet tiling",
      "unit": "sq ft",
      "essentialRate": 15,
      "premiumRate": 25,
      "signatureRate": 38,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Durable flooring / tiles",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Wall tile - wet": {
      "trade": "Flooring/Tiling",
      "workGroup": "Wet tiling",
      "unit": "sq ft",
      "essentialRate": 15,
      "premiumRate": 25,
      "signatureRate": 38,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Durable flooring / tiles",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Skirting": {
      "trade": "Flooring/Tiling",
      "workGroup": "Flooring / Tiling",
      "unit": "lin ft",
      "essentialRate": 4,
      "premiumRate": 7,
      "signatureRate": 12,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Durable flooring / tiles",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Paint - walls & ceiling": {
      "trade": "Painting/Prep",
      "workGroup": "Painting",
      "unit": "sq ft",
      "essentialRate": 2.5,
      "premiumRate": 3.75,
      "signatureRate": 5.25,
      "ageSensitive": true,
      "layoutSensitive": false,
      "rentalClass": "Paint / maintenance",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Feature wall finish": {
      "trade": "Carpentry",
      "workGroup": "Carpentry",
      "unit": "sq ft",
      "essentialRate": 12,
      "premiumRate": 45,
      "signatureRate": 90,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Decorative carpentry",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Plaster ceiling": {
      "trade": "Ceiling",
      "workGroup": "Plaster ceiling",
      "unit": "sq ft",
      "essentialRate": 8,
      "premiumRate": 18,
      "signatureRate": 30,
      "ageSensitive": true,
      "layoutSensitive": false,
      "rentalClass": "Ceiling / decorative finish",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Waterproofing - floor": {
      "trade": "Waterproofing",
      "workGroup": "Waterproofing",
      "unit": "sq ft",
      "essentialRate": 8,
      "premiumRate": 12,
      "signatureRate": 16,
      "ageSensitive": true,
      "layoutSensitive": true,
      "rentalClass": "Safety / hidden services",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Waterproofing - shower walls": {
      "trade": "Waterproofing",
      "workGroup": "Waterproofing",
      "unit": "sq ft",
      "essentialRate": 8,
      "premiumRate": 12,
      "signatureRate": 16,
      "ageSensitive": true,
      "layoutSensitive": true,
      "rentalClass": "Safety / hidden services",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Non-structural wall hacking": {
      "trade": "Demolition",
      "workGroup": "Hacking",
      "unit": "sq ft",
      "essentialRate": 15,
      "premiumRate": 15,
      "signatureRate": 15,
      "ageSensitive": true,
      "layoutSensitive": true,
      "rentalClass": "Hacking / site prep",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Lighting point - ceiling": {
      "trade": "Electrical",
      "workGroup": "Electrical / Lighting",
      "unit": "point",
      "essentialRate": 80,
      "premiumRate": 100,
      "signatureRate": 120,
      "ageSensitive": true,
      "layoutSensitive": true,
      "rentalClass": "Safety / hidden services",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Downlight / ceiling fixture": {
      "trade": "Electrical",
      "workGroup": "Electrical / Lighting",
      "unit": "unit",
      "essentialRate": 35,
      "premiumRate": 80,
      "signatureRate": 180,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Decorative FF&E / lighting",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Lighting point - accent / wall": {
      "trade": "Electrical",
      "workGroup": "Electrical / Lighting",
      "unit": "point",
      "essentialRate": 100,
      "premiumRate": 120,
      "signatureRate": 150,
      "ageSensitive": true,
      "layoutSensitive": true,
      "rentalClass": "Safety / hidden services",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Accent / wall light fixture": {
      "trade": "Electrical",
      "workGroup": "Electrical / Lighting",
      "unit": "unit",
      "essentialRate": 120,
      "premiumRate": 300,
      "signatureRate": 800,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Decorative FF&E / lighting",
      "lowFactor": 0.7,
      "highFactor": 1.5,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "13A socket point": {
      "trade": "Electrical",
      "workGroup": "Electrical / Lighting",
      "unit": "point",
      "essentialRate": 180,
      "premiumRate": 250,
      "signatureRate": 350,
      "ageSensitive": true,
      "layoutSensitive": true,
      "rentalClass": "Safety / hidden services",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Dedicated appliance / AC point": {
      "trade": "Electrical",
      "workGroup": "Electrical / Lighting",
      "unit": "point",
      "essentialRate": 400,
      "premiumRate": 500,
      "signatureRate": 650,
      "ageSensitive": true,
      "layoutSensitive": true,
      "rentalClass": "Safety / hidden services",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Data / TV point": {
      "trade": "Electrical",
      "workGroup": "Electrical / Lighting",
      "unit": "point",
      "essentialRate": 150,
      "premiumRate": 200,
      "signatureRate": 275,
      "ageSensitive": true,
      "layoutSensitive": true,
      "rentalClass": "Safety / hidden services",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "LED strip": {
      "trade": "Electrical",
      "workGroup": "Electrical / Lighting",
      "unit": "lin ft",
      "essentialRate": 25,
      "premiumRate": 45,
      "signatureRate": 75,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Decorative FF&E / lighting",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Ceiling fan": {
      "trade": "Electrical",
      "workGroup": "Electrical / Lighting",
      "unit": "unit",
      "essentialRate": 275,
      "premiumRate": 650,
      "signatureRate": 1300,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Appliances / HVAC",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Dimmer / smart control": {
      "trade": "Electrical",
      "workGroup": "Electrical / Lighting",
      "unit": "point",
      "essentialRate": 0,
      "premiumRate": 180,
      "signatureRate": 450,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Decorative FF&E / lighting",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Hot/cold water point": {
      "trade": "Plumbing",
      "workGroup": "Plumbing / Sanitary",
      "unit": "point",
      "essentialRate": 450,
      "premiumRate": 450,
      "signatureRate": 450,
      "ageSensitive": true,
      "layoutSensitive": true,
      "rentalClass": "Safety / hidden services",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Drain / waste point": {
      "trade": "Plumbing",
      "workGroup": "Plumbing / Sanitary",
      "unit": "point",
      "essentialRate": 450,
      "premiumRate": 450,
      "signatureRate": 450,
      "ageSensitive": true,
      "layoutSensitive": true,
      "rentalClass": "Safety / hidden services",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Wardrobe": {
      "trade": "Carpentry",
      "workGroup": "Carpentry",
      "unit": "lin ft",
      "essentialRate": 325,
      "premiumRate": 500,
      "signatureRate": 700,
      "ageSensitive": true,
      "layoutSensitive": false,
      "rentalClass": "Core carpentry",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Dressing / study built-in": {
      "trade": "Carpentry",
      "workGroup": "Carpentry",
      "unit": "lin ft",
      "essentialRate": 300,
      "premiumRate": 500,
      "signatureRate": 750,
      "ageSensitive": true,
      "layoutSensitive": false,
      "rentalClass": "Core carpentry",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Custom headboard": {
      "trade": "Carpentry",
      "workGroup": "Carpentry",
      "unit": "lin ft",
      "essentialRate": 350,
      "premiumRate": 600,
      "signatureRate": 900,
      "ageSensitive": true,
      "layoutSensitive": false,
      "rentalClass": "Decorative carpentry",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "TV / media carpentry": {
      "trade": "Carpentry",
      "workGroup": "Carpentry",
      "unit": "lin ft",
      "essentialRate": 180,
      "premiumRate": 700,
      "signatureRate": 1200,
      "ageSensitive": true,
      "layoutSensitive": false,
      "rentalClass": "Decorative carpentry",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Display / storage cabinetry": {
      "trade": "Carpentry",
      "workGroup": "Carpentry",
      "unit": "lin ft",
      "essentialRate": 325,
      "premiumRate": 550,
      "signatureRate": 800,
      "ageSensitive": true,
      "layoutSensitive": false,
      "rentalClass": "Core carpentry",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Shoe cabinet": {
      "trade": "Carpentry",
      "workGroup": "Carpentry",
      "unit": "lin ft",
      "essentialRate": 300,
      "premiumRate": 500,
      "signatureRate": 900,
      "ageSensitive": true,
      "layoutSensitive": false,
      "rentalClass": "Core carpentry",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Kitchen base cabinet": {
      "trade": "Carpentry",
      "workGroup": "Carpentry",
      "unit": "lin ft",
      "essentialRate": 500,
      "premiumRate": 700,
      "signatureRate": 950,
      "ageSensitive": true,
      "layoutSensitive": false,
      "rentalClass": "Core carpentry",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Kitchen wall cabinet": {
      "trade": "Carpentry",
      "workGroup": "Carpentry",
      "unit": "lin ft",
      "essentialRate": 250,
      "premiumRate": 400,
      "signatureRate": 600,
      "ageSensitive": true,
      "layoutSensitive": false,
      "rentalClass": "Core carpentry",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Kitchen tall cabinet": {
      "trade": "Carpentry",
      "workGroup": "Carpentry",
      "unit": "lin ft",
      "essentialRate": 500,
      "premiumRate": 750,
      "signatureRate": 1100,
      "ageSensitive": true,
      "layoutSensitive": false,
      "rentalClass": "Core carpentry",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Kitchen countertop": {
      "trade": "Carpentry",
      "workGroup": "Carpentry",
      "unit": "sq ft",
      "essentialRate": 135,
      "premiumRate": 300,
      "signatureRate": 430,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Core carpentry",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Kitchen backsplash": {
      "trade": "Flooring/Tiling",
      "workGroup": "Wet tiling",
      "unit": "sq ft",
      "essentialRate": 45,
      "premiumRate": 90,
      "signatureRate": 180,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Durable flooring / tiles",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Kitchen island": {
      "trade": "Carpentry",
      "workGroup": "Carpentry",
      "unit": "lin ft",
      "essentialRate": 1250,
      "premiumRate": 1800,
      "signatureRate": 3200,
      "ageSensitive": true,
      "layoutSensitive": false,
      "rentalClass": "Decorative carpentry",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Bathroom vanity": {
      "trade": "Carpentry",
      "workGroup": "Carpentry",
      "unit": "lin ft",
      "essentialRate": 500,
      "premiumRate": 750,
      "signatureRate": 1100,
      "ageSensitive": true,
      "layoutSensitive": false,
      "rentalClass": "Core carpentry",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Laundry / utility cabinetry": {
      "trade": "Carpentry",
      "workGroup": "Carpentry",
      "unit": "lin ft",
      "essentialRate": 300,
      "premiumRate": 450,
      "signatureRate": 650,
      "ageSensitive": true,
      "layoutSensitive": false,
      "rentalClass": "Core carpentry",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Built-in bench / storage": {
      "trade": "Carpentry",
      "workGroup": "Carpentry",
      "unit": "lin ft",
      "essentialRate": 300,
      "premiumRate": 500,
      "signatureRate": 750,
      "ageSensitive": true,
      "layoutSensitive": false,
      "rentalClass": "Core carpentry",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Wet/dry kitchen partition": {
      "trade": "Carpentry",
      "workGroup": "Carpentry",
      "unit": "set",
      "essentialRate": 2500,
      "premiumRate": 3500,
      "signatureRate": 5000,
      "ageSensitive": true,
      "layoutSensitive": true,
      "rentalClass": "Core carpentry",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "WC": {
      "trade": "Plumbing",
      "workGroup": "Plumbing / Sanitary",
      "unit": "unit",
      "essentialRate": 500,
      "premiumRate": 1500,
      "signatureRate": 2800,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Sanitary / fixtures",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Basin": {
      "trade": "Plumbing",
      "workGroup": "Plumbing / Sanitary",
      "unit": "unit",
      "essentialRate": 350,
      "premiumRate": 750,
      "signatureRate": 1600,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Sanitary / fixtures",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Basin tap": {
      "trade": "Plumbing",
      "workGroup": "Plumbing / Sanitary",
      "unit": "unit",
      "essentialRate": 200,
      "premiumRate": 500,
      "signatureRate": 1200,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Sanitary / fixtures",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Shower set": {
      "trade": "Plumbing",
      "workGroup": "Plumbing / Sanitary",
      "unit": "set",
      "essentialRate": 400,
      "premiumRate": 1000,
      "signatureRate": 2500,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Sanitary / fixtures",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Shower screen": {
      "trade": "Plumbing",
      "workGroup": "Plumbing / Sanitary",
      "unit": "set",
      "essentialRate": 1200,
      "premiumRate": 1800,
      "signatureRate": 3000,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Sanitary / fixtures",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Water heater": {
      "trade": "Plumbing",
      "workGroup": "Plumbing / Sanitary",
      "unit": "unit",
      "essentialRate": 500,
      "premiumRate": 900,
      "signatureRate": 1500,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Appliances / HVAC",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Bathroom mirror": {
      "trade": "FF&E",
      "workGroup": "FF&E",
      "unit": "unit",
      "essentialRate": 300,
      "premiumRate": 650,
      "signatureRate": 1300,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Core FF&E",
      "lowFactor": 0.7,
      "highFactor": 1.5,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Bathroom accessories": {
      "trade": "FF&E",
      "workGroup": "FF&E",
      "unit": "set",
      "essentialRate": 250,
      "premiumRate": 600,
      "signatureRate": 1200,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Core FF&E",
      "lowFactor": 0.7,
      "highFactor": 1.5,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Bathroom exhaust fan": {
      "trade": "Electrical",
      "workGroup": "Electrical / Lighting",
      "unit": "unit",
      "essentialRate": 250,
      "premiumRate": 450,
      "signatureRate": 750,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Appliances / HVAC",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Bathtub": {
      "trade": "Plumbing",
      "workGroup": "Plumbing / Sanitary",
      "unit": "unit",
      "essentialRate": 2000,
      "premiumRate": 4500,
      "signatureRate": 9000,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Sanitary / fixtures",
      "lowFactor": 0.7,
      "highFactor": 1.5,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Kitchen sink & tap": {
      "trade": "Plumbing",
      "workGroup": "Plumbing / Sanitary",
      "unit": "set",
      "essentialRate": 700,
      "premiumRate": 1500,
      "signatureRate": 3000,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Sanitary / fixtures",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Utility sink & tap": {
      "trade": "Plumbing",
      "workGroup": "Plumbing / Sanitary",
      "unit": "set",
      "essentialRate": 450,
      "premiumRate": 900,
      "signatureRate": 1800,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Sanitary / fixtures",
      "lowFactor": 0.8,
      "highFactor": 1.3,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Hood & hob": {
      "trade": "FF&E",
      "workGroup": "FF&E",
      "unit": "set",
      "essentialRate": 1600,
      "premiumRate": 3500,
      "signatureRate": 8000,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Appliances / HVAC",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Kitchen appliance set": {
      "trade": "FF&E",
      "workGroup": "FF&E",
      "unit": "set",
      "essentialRate": 3000,
      "premiumRate": 8000,
      "signatureRate": 18000,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Appliances / HVAC",
      "lowFactor": 0.7,
      "highFactor": 1.5,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Laundry drying rack": {
      "trade": "FF&E",
      "workGroup": "FF&E",
      "unit": "unit",
      "essentialRate": 450,
      "premiumRate": 900,
      "signatureRate": 2200,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Core FF&E",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Washer / dryer set": {
      "trade": "FF&E",
      "workGroup": "FF&E",
      "unit": "set",
      "essentialRate": 2500,
      "premiumRate": 5000,
      "signatureRate": 10000,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Appliances / HVAC",
      "lowFactor": 0.7,
      "highFactor": 1.5,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Bed & mattress": {
      "trade": "FF&E",
      "workGroup": "FF&E",
      "unit": "set",
      "essentialRate": 1700,
      "premiumRate": 5000,
      "signatureRate": null,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Core FF&E",
      "lowFactor": 0.7,
      "highFactor": 1.5,
      "ffeBrandMix": true,
      "luxuryRate": 35000,
      "largeRoomScale": true,
      "essentialLowFactor": 0.85,
      "essentialHighFactor": 1.25,
      "premiumLowFactor": 0.8,
      "premiumHighFactor": 1.35,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Loose headboard": {
      "trade": "FF&E",
      "workGroup": "FF&E",
      "unit": "unit",
      "essentialRate": 550,
      "premiumRate": 1800,
      "signatureRate": 3500,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Decorative FF&E / lighting",
      "lowFactor": 0.7,
      "highFactor": 1.5,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": 0.85,
      "essentialHighFactor": 1.25,
      "premiumLowFactor": 0.8,
      "premiumHighFactor": 1.35,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Bedside table": {
      "trade": "FF&E",
      "workGroup": "FF&E",
      "unit": "unit",
      "essentialRate": 280,
      "premiumRate": 900,
      "signatureRate": null,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Core FF&E",
      "lowFactor": 0.7,
      "highFactor": 1.5,
      "ffeBrandMix": true,
      "luxuryRate": 8000,
      "largeRoomScale": false,
      "essentialLowFactor": 0.85,
      "essentialHighFactor": 1.25,
      "premiumLowFactor": 0.8,
      "premiumHighFactor": 1.35,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Sofa seating group": {
      "trade": "FF&E",
      "workGroup": "FF&E",
      "unit": "set",
      "essentialRate": 2300,
      "premiumRate": 9500,
      "signatureRate": null,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Core FF&E",
      "lowFactor": 0.7,
      "highFactor": 1.5,
      "ffeBrandMix": true,
      "luxuryRate": 60000,
      "largeRoomScale": true,
      "essentialLowFactor": 0.85,
      "essentialHighFactor": 1.25,
      "premiumLowFactor": 0.8,
      "premiumHighFactor": 1.35,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Accent / lounge chair": {
      "trade": "FF&E",
      "workGroup": "FF&E",
      "unit": "unit",
      "essentialRate": 550,
      "premiumRate": 2500,
      "signatureRate": null,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Decorative FF&E / lighting",
      "lowFactor": 0.7,
      "highFactor": 1.5,
      "ffeBrandMix": true,
      "luxuryRate": 20000,
      "largeRoomScale": false,
      "essentialLowFactor": 0.85,
      "essentialHighFactor": 1.25,
      "premiumLowFactor": 0.8,
      "premiumHighFactor": 1.35,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Coffee table": {
      "trade": "FF&E",
      "workGroup": "FF&E",
      "unit": "unit",
      "essentialRate": 350,
      "premiumRate": 1800,
      "signatureRate": null,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Decorative FF&E / lighting",
      "lowFactor": 0.7,
      "highFactor": 1.5,
      "ffeBrandMix": true,
      "luxuryRate": 20000,
      "largeRoomScale": true,
      "essentialLowFactor": 0.85,
      "essentialHighFactor": 1.25,
      "premiumLowFactor": 0.8,
      "premiumHighFactor": 1.35,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Side table": {
      "trade": "FF&E",
      "workGroup": "FF&E",
      "unit": "unit",
      "essentialRate": 280,
      "premiumRate": 900,
      "signatureRate": null,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Decorative FF&E / lighting",
      "lowFactor": 0.7,
      "highFactor": 1.5,
      "ffeBrandMix": true,
      "luxuryRate": 8000,
      "largeRoomScale": false,
      "essentialLowFactor": 0.85,
      "essentialHighFactor": 1.25,
      "premiumLowFactor": 0.8,
      "premiumHighFactor": 1.35,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Dining table": {
      "trade": "FF&E",
      "workGroup": "FF&E",
      "unit": "unit",
      "essentialRate": 900,
      "premiumRate": 6500,
      "signatureRate": null,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Core FF&E",
      "lowFactor": 0.7,
      "highFactor": 1.5,
      "ffeBrandMix": true,
      "luxuryRate": 50000,
      "largeRoomScale": true,
      "essentialLowFactor": 0.85,
      "essentialHighFactor": 1.25,
      "premiumLowFactor": 0.8,
      "premiumHighFactor": 1.35,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Dining chair": {
      "trade": "FF&E",
      "workGroup": "FF&E",
      "unit": "unit",
      "essentialRate": 220,
      "premiumRate": 1100,
      "signatureRate": null,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Core FF&E",
      "lowFactor": 0.7,
      "highFactor": 1.5,
      "ffeBrandMix": true,
      "luxuryRate": 7000,
      "largeRoomScale": false,
      "essentialLowFactor": 0.85,
      "essentialHighFactor": 1.25,
      "premiumLowFactor": 0.8,
      "premiumHighFactor": 1.35,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Loose desk": {
      "trade": "FF&E",
      "workGroup": "FF&E",
      "unit": "unit",
      "essentialRate": 550,
      "premiumRate": 2000,
      "signatureRate": null,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Core FF&E",
      "lowFactor": 0.7,
      "highFactor": 1.5,
      "ffeBrandMix": true,
      "luxuryRate": 15000,
      "largeRoomScale": false,
      "essentialLowFactor": 0.85,
      "essentialHighFactor": 1.25,
      "premiumLowFactor": 0.8,
      "premiumHighFactor": 1.35,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Desk chair": {
      "trade": "FF&E",
      "workGroup": "FF&E",
      "unit": "unit",
      "essentialRate": 350,
      "premiumRate": 1400,
      "signatureRate": null,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Core FF&E",
      "lowFactor": 0.7,
      "highFactor": 1.5,
      "ffeBrandMix": true,
      "luxuryRate": 8000,
      "largeRoomScale": false,
      "essentialLowFactor": 0.85,
      "essentialHighFactor": 1.25,
      "premiumLowFactor": 0.8,
      "premiumHighFactor": 1.35,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Outdoor furniture set": {
      "trade": "FF&E",
      "workGroup": "FF&E",
      "unit": "set",
      "essentialRate": 1100,
      "premiumRate": 5500,
      "signatureRate": null,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Core FF&E",
      "lowFactor": 0.7,
      "highFactor": 1.5,
      "ffeBrandMix": true,
      "luxuryRate": 30000,
      "largeRoomScale": true,
      "essentialLowFactor": 0.85,
      "essentialHighFactor": 1.25,
      "premiumLowFactor": 0.8,
      "premiumHighFactor": 1.35,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Curtains / blinds set": {
      "trade": "FF&E",
      "workGroup": "FF&E",
      "unit": "window set",
      "essentialRate": 400,
      "premiumRate": 850,
      "signatureRate": 1600,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Core FF&E",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": 0.85,
      "essentialHighFactor": 1.25,
      "premiumLowFactor": 0.8,
      "premiumHighFactor": 1.35,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Pendant / chandelier": {
      "trade": "FF&E",
      "workGroup": "FF&E",
      "unit": "unit",
      "essentialRate": 350,
      "premiumRate": 1800,
      "signatureRate": 8000,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Decorative FF&E / lighting",
      "lowFactor": 0.7,
      "highFactor": 1.5,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": 0.85,
      "essentialHighFactor": 1.25,
      "premiumLowFactor": 0.8,
      "premiumHighFactor": 1.35,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Rug / decor allowance": {
      "trade": "FF&E",
      "workGroup": "FF&E",
      "unit": "set",
      "essentialRate": 450,
      "premiumRate": 2500,
      "signatureRate": 7000,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Decorative FF&E / lighting",
      "lowFactor": 0.7,
      "highFactor": 1.5,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": 0.85,
      "essentialHighFactor": 1.25,
      "premiumLowFactor": 0.8,
      "premiumHighFactor": 1.35,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Console / mirror set": {
      "trade": "FF&E",
      "workGroup": "FF&E",
      "unit": "set",
      "essentialRate": 700,
      "premiumRate": 2500,
      "signatureRate": null,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Decorative FF&E / lighting",
      "lowFactor": 0.7,
      "highFactor": 1.5,
      "ffeBrandMix": true,
      "luxuryRate": 15000,
      "largeRoomScale": false,
      "essentialLowFactor": 0.85,
      "essentialHighFactor": 1.25,
      "premiumLowFactor": 0.8,
      "premiumHighFactor": 1.35,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Planter / greenery set": {
      "trade": "FF&E",
      "workGroup": "FF&E",
      "unit": "set",
      "essentialRate": 280,
      "premiumRate": 1000,
      "signatureRate": 2000,
      "ageSensitive": false,
      "layoutSensitive": false,
      "rentalClass": "Decorative FF&E / lighting",
      "lowFactor": 0.7,
      "highFactor": 1.5,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": 0.85,
      "essentialHighFactor": 1.25,
      "premiumLowFactor": 0.8,
      "premiumHighFactor": 1.35,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Aircon 1.0HP": {
      "trade": "HVAC",
      "workGroup": "HVAC / Aircon",
      "unit": "unit",
      "essentialRate": 1600,
      "premiumRate": 2200,
      "signatureRate": 2700,
      "ageSensitive": true,
      "layoutSensitive": true,
      "rentalClass": "Appliances / HVAC",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Aircon 1.5HP": {
      "trade": "HVAC",
      "workGroup": "HVAC / Aircon",
      "unit": "unit",
      "essentialRate": 1900,
      "premiumRate": 2500,
      "signatureRate": 3200,
      "ageSensitive": true,
      "layoutSensitive": true,
      "rentalClass": "Appliances / HVAC",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Aircon 2.0HP": {
      "trade": "HVAC",
      "workGroup": "HVAC / Aircon",
      "unit": "unit",
      "essentialRate": 2700,
      "premiumRate": 3400,
      "signatureRate": 4100,
      "ageSensitive": true,
      "layoutSensitive": true,
      "rentalClass": "Appliances / HVAC",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    },
    "Aircon 2.5HP+": {
      "trade": "HVAC",
      "workGroup": "HVAC / Aircon",
      "unit": "unit",
      "essentialRate": 3500,
      "premiumRate": 4400,
      "signatureRate": 5500,
      "ageSensitive": true,
      "layoutSensitive": true,
      "rentalClass": "Appliances / HVAC",
      "lowFactor": 0.85,
      "highFactor": 1.2,
      "ffeBrandMix": false,
      "luxuryRate": null,
      "largeRoomScale": false,
      "essentialLowFactor": null,
      "essentialHighFactor": null,
      "premiumLowFactor": null,
      "premiumHighFactor": null,
      "signatureLowFactor": null,
      "signatureHighFactor": null
    }
  },
  "AGE_FACTORS": {
    "0-5": {
      "Demolition": 0.9,
      "Flooring/Tiling": 1,
      "Painting/Prep": 0.95,
      "Ceiling": 1,
      "Electrical": 0.95,
      "Plumbing": 0.95,
      "Waterproofing": 0.95,
      "Carpentry": 1,
      "HVAC": 0.95,
      "FF&E": 1
    },
    "6-15": {
      "Demolition": 0.95,
      "Flooring/Tiling": 1,
      "Painting/Prep": 1,
      "Ceiling": 1,
      "Electrical": 1,
      "Plumbing": 1,
      "Waterproofing": 1,
      "Carpentry": 1,
      "HVAC": 1,
      "FF&E": 1
    },
    "16-25": {
      "Demolition": 1.05,
      "Flooring/Tiling": 1.02,
      "Painting/Prep": 1.05,
      "Ceiling": 1.03,
      "Electrical": 1.1,
      "Plumbing": 1.1,
      "Waterproofing": 1.1,
      "Carpentry": 1,
      "HVAC": 1.05,
      "FF&E": 1
    },
    "26-35": {
      "Demolition": 1.15,
      "Flooring/Tiling": 1.04,
      "Painting/Prep": 1.12,
      "Ceiling": 1.08,
      "Electrical": 1.25,
      "Plumbing": 1.25,
      "Waterproofing": 1.2,
      "Carpentry": 1.02,
      "HVAC": 1.08,
      "FF&E": 1
    },
    "36-50": {
      "Demolition": 1.25,
      "Flooring/Tiling": 1.06,
      "Painting/Prep": 1.2,
      "Ceiling": 1.12,
      "Electrical": 1.45,
      "Plumbing": 1.5,
      "Waterproofing": 1.35,
      "Carpentry": 1.04,
      "HVAC": 1.12,
      "FF&E": 1
    },
    "50+": {
      "Demolition": 1.35,
      "Flooring/Tiling": 1.1,
      "Painting/Prep": 1.3,
      "Ceiling": 1.18,
      "Electrical": 1.65,
      "Plumbing": 1.75,
      "Waterproofing": 1.5,
      "Carpentry": 1.06,
      "HVAC": 1.18,
      "FF&E": 1
    },
    "Unknown old": {
      "Demolition": 1.2,
      "Flooring/Tiling": 1.05,
      "Painting/Prep": 1.15,
      "Ceiling": 1.1,
      "Electrical": 1.35,
      "Plumbing": 1.4,
      "Waterproofing": 1.3,
      "Carpentry": 1.03,
      "HVAC": 1.1,
      "FF&E": 1
    }
  },
  "CONTINGENCY_BY_AGEBAND": {
    "0-5": 0.075,
    "6-15": 0.1,
    "16-25": 0.125,
    "26-35": 0.15,
    "36-50": 0.175,
    "50+": 0.225,
    "Unknown old": 0.15
  },
  "SITE_FACTORS": {
    "Condominium": 1.03,
    "Apartment / walk-up": 1.05,
    "Terrace": 1,
    "Semi-D": 1,
    "Bungalow": 1
  },
  "STATE_FACTORS": {
    "New developer unit": 1,
    "Resale / older property": 1
  },
  "CONDITION_FACTORS": {
    "Excellent": 0.9,
    "Good": 0.95,
    "Average": 1,
    "Poor": 1.15,
    "Unknown": 1.05
  },
  "LAYOUT_FACTORS": {
    "Keep layout": 1,
    "Minor relocation": 1.1,
    "Major relocation": 1.25
  },
  "RENTAL_FACTORS": {
    "Safety / hidden services": [
      1,
      1,
      1
    ],
    "Hacking / site prep": [
      1,
      1,
      1
    ],
    "Durable flooring / tiles": [
      0.9,
      0.8,
      0.65
    ],
    "Paint / maintenance": [
      0.95,
      0.9,
      0.8
    ],
    "Ceiling / decorative finish": [
      0.8,
      0.6,
      0.45
    ],
    "Core carpentry": [
      0.9,
      0.8,
      0.65
    ],
    "Decorative carpentry": [
      0.65,
      0.5,
      0.35
    ],
    "Sanitary / fixtures": [
      0.95,
      0.8,
      0.6
    ],
    "Appliances / HVAC": [
      0.95,
      0.85,
      0.75
    ],
    "Core FF&E": [
      0.8,
      0.65,
      0.5
    ],
    "Decorative FF&E / lighting": [
      0.6,
      0.4,
      0.25
    ]
  },
  "ELECTRICAL_EXTENT_FACTORS": {
    "Auto": [
      1,
      0.6
    ],
    "Additions only": [
      1,
      0.35
    ],
    "Partial upgrade": [
      0.65,
      0.65
    ],
    "Full rewiring": [
      1,
      1
    ]
  },
  "PLUMBING_EXTENT_FACTORS": {
    "Auto": [
      0,
      0.5
    ],
    "Fixtures only": [
      0,
      0
    ],
    "Selected reroute": [
      0.5,
      0.5
    ],
    "Full replumb": [
      1,
      1
    ]
  },
  "BATHROOM_SCOPE_FACTORS": {
    "Refresh": {
      "hacking": 0,
      "wetTiling": 0,
      "waterproofing": 0,
      "electrical": 0.5,
      "plumbingPoints": 0,
      "sanitaryFixtures": 1,
      "carpentry": 0.75,
      "paintCeiling": 1,
      "ffe": 1
    },
    "Standard renovation": {
      "hacking": 1,
      "wetTiling": 1,
      "waterproofing": 1,
      "electrical": 0.75,
      "plumbingPoints": 1,
      "sanitaryFixtures": 1,
      "carpentry": 1,
      "paintCeiling": 1,
      "ffe": 1
    },
    "Full rebuild": {
      "hacking": 1,
      "wetTiling": 1,
      "waterproofing": 1,
      "electrical": 1,
      "plumbingPoints": 1,
      "sanitaryFixtures": 1,
      "carpentry": 1,
      "paintCeiling": 1,
      "ffe": 1
    }
  },
  "PROJECT_DEFAULTS": {
    "lowScenarioFactor": 1,
    "highScenarioFactor": 1,
    "dryFloorWastage": 0.075,
    "wetTileWastage": 0.1,
    "netPaintWallFactor": 0.85,
    "lightingDesignAllowance": 1.2,
    "prelimRate": 0,
    "defaultCeilingHeight": 9.5,
    "marketEscalationFactor": 1,
    "lowTypicalScopeWeight": 0.75,
    "premiumLowEssentialShare": 0.5,
    "premiumLowPremiumShare": 0.5
  },
  "SIZE_ZONES": [
    {
      "zone": "Zone 1",
      "minArea": 0,
      "maxArea": 2000,
      "privateFactor": 1,
      "sharedFactor": 1,
      "highEligibleWeight": 0
    },
    {
      "zone": "Zone 2",
      "minArea": 2001,
      "maxArea": 3000,
      "privateFactor": 1.04,
      "sharedFactor": 1.06,
      "highEligibleWeight": 0.35
    },
    {
      "zone": "Zone 3",
      "minArea": 3001,
      "maxArea": 4500,
      "privateFactor": 1.08,
      "sharedFactor": 1.12,
      "highEligibleWeight": 0.65
    },
    {
      "zone": "Zone 4",
      "minArea": 4501,
      "maxArea": Infinity,
      "privateFactor": 1.12,
      "sharedFactor": 1.18,
      "highEligibleWeight": 1
    }
  ],
  "BEDROOM_SHARED_FACTORS": [
    {
      "minBedrooms": 0,
      "maxBedrooms": 3,
      "factor": 1
    },
    {
      "minBedrooms": 4,
      "maxBedrooms": 4,
      "factor": 1.03
    },
    {
      "minBedrooms": 5,
      "maxBedrooms": 5,
      "factor": 1.06
    },
    {
      "minBedrooms": 6,
      "maxBedrooms": Infinity,
      "factor": 1.09
    }
  ],
  "SIGNATURE_BRAND_MIX": {
    "low": {
      "premiumShare": 0.8,
      "luxuryShare": 0.2
    },
    "expected": {
      "premiumShare": 0.5,
      "luxuryShare": 0.5
    },
    "high": {
      "premiumShare": 0.3,
      "luxuryShare": 0.7
    }
  },
  "LARGE_ROOM_SCALE": [
    {
      "minArea": 0,
      "maxArea": 200,
      "Essential": 1,
      "Premium": 1,
      "Signature": 1
    },
    {
      "minArea": 201,
      "maxArea": 350,
      "Essential": 1,
      "Premium": 1.08,
      "Signature": 1.12
    },
    {
      "minArea": 351,
      "maxArea": 550,
      "Essential": 1.03,
      "Premium": 1.18,
      "Signature": 1.3
    },
    {
      "minArea": 551,
      "maxArea": Infinity,
      "Essential": 1.05,
      "Premium": 1.3,
      "Signature": 1.5
    }
  ],
  "MODEL_VERSION": "v9",
  "RATE_AUDIT_DATE": "2026-08-22"
};
}));

